<template>
    <div class="request-page">
        <page-header :title="title" :items="items" />

        <b-alert v-if="request.id" show :variant="variant">
            Request {{ request.status }}
        </b-alert>

        <div v-if="request.id" class="row">
            <div class="col-xl-9 mb-3">
                <div class="card">
                    <div class="card-body">
                        <edit-form
                            :key="isAnswered"
                            v-model="request"
                            :validation="$v"
                            :server-errors="serverErrors"
                            :is-answered="isAnswered"
                        />
                    </div>
                </div>

                <div v-if="request.files.length" class="card mt-2">
                    <div class="card-body">
                        <div class="form-group col-12 request-files">
                            <h5>Files</h5>

                            <ul>
                                <li
                                    v-for="file in request.files"
                                    :key="file.name"
                                >
                                    <a :href="getDocumentUrl(file)">
                                        {{ file.originalName }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-3 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div v-if="!isAnswered" class="mb-3 change-status">
                            <button
                                class="btn btn-success btn-static waves-effect waves-light m-1"
                                @click="accept"
                            >
                                Accept
                            </button>
                            <button
                                class="btn btn-danger btn-static waves-effect waves-light m-1"
                                @click="reject"
                            >
                                Reject
                            </button>
                        </div>

                        <item-information
                            :sections="sections"
                            :options="options"
                            :item="request"
                            edit-mode
                        />
                    </div>
                </div>
            </div>
        </div>
        <skeleton-loader v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes as HTTP } from 'http-status-codes';
import { mediaUrl } from '@/config';
import EditForm from '@/components/requests/EditForm';
import ItemInformation from '@/components/elements/ItemInformation';

export default {
    request: {
        title: 'Manage Request'
    },

    validations: {
        request: {
            stars: {
                isFormatValid: value => value >= 0
            }
        }
    },

    components: {
        EditForm,
        ItemInformation
    },

    data() {
        const { id = null } = this.$route.params;

        return {
            title: 'Edit request',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Requests',
                    to: '/requests'
                },
                {
                    text: 'Edit',
                    active: true
                }
            ],
            id,
            request: {},
            serverErrors: [],
            sections: {
                status: true
            },
            options: {
                deleteButton: false
            }
        };
    },

    computed: {
        isAnswered() {
            return this.request.status !== 'pending';
        },

        variant() {
            const { status } = this.request;

            const variants = {
                accepted: 'success',
                rejected: 'danger'
            };

            return variants[status] || 'secondary';
        }
    },

    async created() {
        try {
            this.request = await this.getRequest(this.id);
        } catch (error) {
            console.error(error);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getRequest: 'requests/show',
            updateRequest: 'requests/update',
            acceptRequest: 'requests/accept',
            rejectRequest: 'requests/reject'
        }),

        async accept() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                this.request = await this.acceptRequest({
                    id: this.request.id,
                    note: this.request.note,
                    stars: this.request.stars
                });
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        async reject() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                this.request = await this.rejectRequest({
                    id: this.request.id,
                    note: this.request.note
                });
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        getDocumentUrl({ name }) {
            return `${mediaUrl}/requests/${this.request.user.id}/${this.request.id}/${name}`;
        }
    }
};
</script>
